// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__+6GuM","welcomeBox":"style__welcomeBox__UDbst","ids":"style__ids__7zp+e"};